module.exports = __webpack_public_path__ + "static/DMSans-Bold-48239f93d88c8b1d7c6fd6207ab4d8ea.woff";